import Box from '@mui/material/Box'
import React from 'react'
import sxs from './_styles/HelpCenterCardsSx'
import { text } from './helpCenter'
import { HelpCenterCardsContainerProps, HelpCenterCardsDef, HelpCenterCardsContainerContentTypeKey } from './_props'
import { BuildIcon, HelpFilledIcon, NewsIcon, SupportAgentIcon } from '../../assets/icons/icons'
import HelpCenterCard from './HelpCenterCard'

const helpCenterCardsDef: Record<HelpCenterCardsContainerContentTypeKey, HelpCenterCardsDef> = {
    helpCenterAndTutorials: {
        id: 1,
        icon: <HelpFilledIcon />,
        title: text.card.helpCenterAndTutorials.title,
        description: text.card.helpCenterAndTutorials.description,
        buttonName: text.card.helpCenterAndTutorials.buttonName,
        url: text.card.helpCenterAndTutorials.url,
    },
    supportContact: {
        id: 2,
        icon: <BuildIcon />,
        title: text.card.supportContact.title,
        description: text.card.supportContact.description,
    },
    exchangeViews: {
        id: 3,
        icon: <SupportAgentIcon />,
        title: text.card.exchangeViews.title,
        description: text.card.exchangeViews.description,
    },
    newsFeed: {
        id: 4,
        icon: <NewsIcon />,
        title: text.card.newsFeed.title,
        description: text.card.newsFeed.description,
        buttonName: text.card.newsFeed.buttonName,
        url: text.card.newsFeed.url,
        colorVariant: 'secondary',
    },
}

const HelpCenterCardsContainer: React.FC<HelpCenterCardsContainerProps> = ({
    contentType = {
        exchangeViews: true,
        helpCenterAndTutorials: true,
        newsFeed: true,
        supportContact: true,
    },
}) => {
    const contentTypes = Object.keys(contentType) as HelpCenterCardsContainerContentTypeKey[]

    const cards: HelpCenterCardsDef[] =
        contentTypes.length === 0
            ? Object.values(helpCenterCardsDef)
            : contentTypes.map((type) => helpCenterCardsDef[type])

    return (
        <Box sx={sxs.cardsContainer}>
            {cards.map((card) => (
                <HelpCenterCard
                    key={card.id}
                    id={card.id}
                    icon={card.icon}
                    title={card.title}
                    description={card.description}
                    buttonName={card.buttonName}
                    url={card.url}
                    colorVariant={card.colorVariant}
                />
            ))}
        </Box>
    )
}

export default HelpCenterCardsContainer
